import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from 'designSystem/components/Tooltip'
import { type FC, type MouseEvent, useCallback, useState } from 'react'
import styled from 'styled-components'

const EllipsisText = styled.span<{ $muted?: boolean }>`
  display: block;
  min-width: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ $muted }) => ($muted ? 'var(--muted-foreground)' : 'inherit')};
`

export const TruncatingLabel: FC<{
  text: string
  muted?: boolean
}> = ({ text, muted = false }) => {
  const [isTruncated, setIsTruncated] = useState(false)

  const onMouseEnter = useCallback((event: MouseEvent<HTMLElement>) => {
    setIsTruncated(
      event.currentTarget.scrollWidth > event.currentTarget.clientWidth
    )
  }, [])

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <EllipsisText $muted={muted} onMouseEnter={onMouseEnter}>
          {text}
        </EllipsisText>
      </TooltipTrigger>
      {isTruncated && <TooltipContent>{text}</TooltipContent>}
    </Tooltip>
  )
}
